import * as React from 'react';
import styles from './index.less';
import img_1_banner from './1.banner@3x.png';
import img_2_background from './2.background@2x.png';
import img_3_schedule from './3.schedule@2x.png';
import img_4_reward from './4.reward@2x.png';
import img_5_autodrome from './5.autodrome@2x.png';
import img_6_FAQ from './6.FAQ@2x.png';
import img_7_rule from './7.rule@2x.png';
import img_sumbit from './submit@2x.png';
import img_share from './share@2x.png';
import img_QRCode from './img_QRCode.png';
import FPropaganda from './FPropaganda';
import FPageFooter from './FPageFooter';
import * as AHooks from 'ahooks';
import { FServiceAPI, FUtil } from '@freelog/tools-lib';
import fCenterMessage from '@/components/fCenterMessage';
// import { Modal } from 'antd';
import copy from 'copy-to-clipboard';
import { connect } from 'dva';
import { ActivityDetailsPageModelState, ConnectState } from '@/models/connect';
import dayjs from 'dayjs';
import FModal from '@/components/FModal';
import fWeiXinShare from '@/components/fWeiXinShare';

interface WidgetProps {
  activityDetailsPage: ActivityDetailsPageModelState;
}

function Widget({ activityDetailsPage }: WidgetProps) {
  const ref_content1 = React.useRef<HTMLImageElement>(null);
  const ref_content2 = React.useRef<HTMLDivElement>(null);
  const ref_content3 = React.useRef<HTMLDivElement>(null);
  const ref_content4 = React.useRef<HTMLDivElement>(null);
  const ref_content5 = React.useRef<HTMLDivElement>(null);
  const ref_content6 = React.useRef<HTMLDivElement>(null);

  const [$isLogined, set$isLogined, get$isLogined] = FUtil.Hook.useGetState<boolean>(false);
  const [$isRegister, set$isRegister, get$isRegister] = FUtil.Hook.useGetState<boolean>(false);
  const [$activated, set$activated, get$activated] = FUtil.Hook.useGetState<number>(1);
  const [$usedCount, set$usedCount, get$usedCount] = FUtil.Hook.useGetState<number>(0);
  const [$showModal, set$showModal, get$showModal] = FUtil.Hook.useGetState<boolean>(false);
  const [$invitationCode, set$invitationCode, get$invitationCode] =
    FUtil.Hook.useGetState<string>('');
  const [$announceTime, set$announceTime, get$announceTime] = FUtil.Hook.useGetState<dayjs.Dayjs>(
    dayjs(activityDetailsPage.endTime).add(1, 'month'),
  );

  AHooks.useMount(async () => {
    if (FUtil.Tool.getUserIDByCookies() === -1) {
      return;
    }
    set$isLogined(true);
    const {
      data,
    }: {
      data: {
        userType: 0 | 1;
      };
    } = await FServiceAPI.User.currentUserInfo();
    set$isRegister(data.userType === 1);
  });

  const position = AHooks.useScroll(
    self.document.querySelector('#layout-content .simplebar-content-wrapper'),
  );

  AHooks.useMount(async () => {
    if (FUtil.Tool.getUserIDByCookies() === -1) {
      return;
    }
    const {
      data,
    }: {
      data: {
        usedCount: number;
        code: string;
      };
    } = await FServiceAPI.TestQualification.codeDetails2({});
    set$invitationCode(data.code);
    set$usedCount(data.usedCount);
  });

  AHooks.useDebounceEffect(
    () => {
      const info1 = ref_content1.current?.getBoundingClientRect();
      const info2 = ref_content2.current?.getBoundingClientRect();
      const info3 = ref_content3.current?.getBoundingClientRect();
      const info4 = ref_content4.current?.getBoundingClientRect();
      const info5 = ref_content5.current?.getBoundingClientRect();
      const info6 = ref_content6.current?.getBoundingClientRect();
      // console.log(info2, 'info2sidofjldkjfljsld');
      if (info6 && info6.top <= 162) {
        set$activated(6);
      } else if (info5 && info5.top <= 162) {
        set$activated(5);
      } else if (info4 && info4.top <= 162) {
        set$activated(4);
      } else if (info3 && info3.top <= 162) {
        set$activated(3);
      } else if (info2 && info2.top <= 162) {
        set$activated(2);
      } else {
        set$activated(1);
      }
    },
    [position],
    {
      wait: 100,
    },
  );

  function scrollTo(top: number) {
    self.document.querySelector('#layout-content .simplebar-content-wrapper')?.scrollBy({
      top,
      behavior: 'smooth',
    });
  }

  function commitWorks() {
    if (!get$isLogined()) {
      self.location.replace(
        FUtil.Format.completeUrlByDomain('user') +
          FUtil.LinkTo.login({
            goTo: self.location.href,
          }),
      );
      return;
    }
    if (!get$isRegister()) {
      // fCenterMessage({ message: '此活动仅对内测用户开放!' });
      self.open(FUtil.Format.completeUrlByDomain('console') + FUtil.LinkTo.invitation());
      return;
    }
    self.open(FUtil.Format.completeUrlByDomain('console') + FUtil.LinkTo.resourceCreator());
  }

  return (
    <div className={styles.styles}>
      <img
        src={img_1_banner}
        alt='banner'
        className={styles.picture}
        style={{ width: '100%', aspectRatio: 12 / 5 }}
        fetchPriority={'high'}
        loading={'eager'}
      />
      <img
        loading={'eager'}
        src={img_2_background}
        fetchPriority={'high'}
        alt='background'
        className={styles.picture}
        ref={ref_content1}
        style={{ height: 774 }}
      />
      <div style={{ height: 50 }} />
      <div className={styles.schedule} ref={ref_content2}>
        <img loading={'lazy'} src={img_3_schedule} alt='schedule' className={styles.picture} />
        <div className={styles.time} style={{ left: 176 }}>
          {/* 2025-08-08 00:00 */}
          {activityDetailsPage.startTime?.format('YYYY-MM-DD HH:mm')}
        </div>
        <div className={styles.time} style={{ left: (176 + 888) / 2 }}>
          {/* 2025-08-08 00:00 */}
          {activityDetailsPage.endTime?.format('YYYY-MM-DD HH:mm')}
        </div>
        <div className={styles.time} style={{ left: 888 }}>
          {/* 2025-08-08 00:00 */}
          {$announceTime?.format('YYYY-MM-DD HH:mm')}
        </div>
      </div>
      <div style={{ height: 50 }} />
      <div className={styles.reward} ref={ref_content3}>
        <img loading={'lazy'} src={img_4_reward} alt='reward' className={styles.picture} />
        <div className={styles.rewardBox}>
          <div className={styles.rewardText}>
            {/* 获奖结果于 2025-08-08 00:00 进行公示，敬请期待～ */}
            获奖结果于 {$announceTime?.format('YYYY-MM-DD HH:mm')} 进行公示，敬请期待～
          </div>
          {/* <div
            className={styles.buttonFilled}
            style={{
              width: 230,
              height: 54,
            }}
          >
            查看获奖公示
          </div> */}
        </div>
      </div>
      <div style={{ height: 50 }} />
      <div className={styles.autodrome} ref={ref_content4}>
        <img loading={'lazy'} src={img_5_autodrome} alt='autodrome' className={styles.picture} />
        <div className={styles.autodromeBox} style={{ top: 1664 }}>
          {$isRegister && (
            <div className={[styles.buttonOutlined, styles.disabled].join(' ')}>已获资格</div>
          )}
          {!$isRegister && (
            <div
              className={styles.buttonOutlined}
              onClick={async () => {
                const {
                  data,
                }: {
                  data: {
                    userType: 0 | 1;
                  };
                } = await FServiceAPI.User.currentUserInfo();

                if (FUtil.Tool.getUserIDByCookies() === -1) {
                  return;
                }

                self.open(
                  FUtil.Format.completeUrlByDomain('console') +
                    FUtil.LinkTo.invitation() +
                    '?type=apply',
                );
              }}
            >
              提交内测申请
            </div>
          )}
        </div>

        <div className={styles.autodromeBox} style={{ top: 1938 }}>
          <div
            className={styles.buttonOutlined}
            onClick={() => {
              self.open('https://widget-docs.freelog.cn/guide/');
            }}
          >
            查看开发指南
          </div>
          <div
            className={styles.buttonOutlined}
            onClick={() => {
              self.open('https://widget-docs.freelog.cn/guide/official.html');
            }}
          >
            查看官方示例
          </div>
        </div>

        <div className={styles.autodromeBox} style={{ top: 2182 }}>
          <div
            className={styles.buttonOutlined}
            onClick={() => {
              self.open('https://widget-docs.freelog.cn/guide/release.html');
            }}
          >
            查看教程
          </div>
          <div
            className={styles.buttonFilled}
            onClick={() => {
              // self.open(
              //   FUtil.Format.completeUrlByDomain('console') +
              //     FUtil.LinkTo.resourceCreator(),
              // );
              commitWorks();
            }}
          >
            提交作品
          </div>
        </div>
        <div
          className={styles.buttonOutlined}
          style={{ position: 'absolute', top: 2808, left: 240 }}
          onClick={() => {
            self.open('https://forum.freelog.cn/category/5/%E4%B8%BB%E9%A2%98%E6%8F%92%E4%BB%B6');
          }}
        >
          前往开发者社区
        </div>
        <div
          className={styles.buttonOutlined}
          style={{ position: 'absolute', top: 2808, left: 790 }}
          onClick={async () => {
            const {
              data,
            }: {
              data: {
                userType: 0 | 1;
              };
            } = await FServiceAPI.User.currentUserInfo();

            if (data.userType === 0) {
              fCenterMessage({ message: '此活动仅对内测用户开放!' });
              return;
            }

            if (get$usedCount() >= 5) {
              fCenterMessage({ message: '邀请好友数量不超过5人' });
              return;
            }
            set$showModal(true);
          }}
        >
          去邀请好友
        </div>
      </div>
      <div style={{ height: 50 }} />
      <div className={styles.FAQ} ref={ref_content5}>
        <img loading={'lazy'} src={img_6_FAQ} alt='FAQ' className={styles.picture} />
        <a
          className={styles.link}
          style={{ position: 'absolute', top: 206, left: 166 }}
          href='https://freelog3.freelog.cn/?theme=%2Freader%3Fid%25M262d0cf48456ff0002e3294fb&w06c513=%2F'
          target='_blank'
        >
          【帮助中心】——【基本概念】
        </a>
        <a
          className={styles.link}
          style={{ position: 'absolute', top: 278, left: 210 }}
          href='https://widget-docs.freelog.cn/'
          target='_blank'
        >
          官方指南
        </a>
        <a
          className={styles.link}
          style={{ position: 'absolute', top: 350, left: 412 }}
          href='https://widget-docs.freelog.cn/api/widget.html'
          target='_blank'
        >
          API 文档
        </a>
        <a
          className={styles.link}
          style={{ position: 'absolute', top: 424, left: 214 }}
          href={FUtil.Format.completeUrlByDomain('console') + FUtil.LinkTo.exampleNodes()}
          target='_blank'
        >
          Freelog示例节点
        </a>
        <a
          className={styles.link}
          style={{ position: 'absolute', top: 594, left: 194 }}
          href='https://github.com/freelogfe/freelog-runtime/discussions'
          target='_blank'
        >
          Github社区
        </a>
        <a
          className={styles.link}
          style={{ position: 'absolute', top: 644, left: 372, fontSize: 14 }}
          href='https://freelog3.freelog.cn/home_freelog-query_id=62d0d04f456ff0002e329537?theme=%2Freader%3Fid%25M262d0d04f456ff0002e329537&w06c513=%2F'
          target='_blank'
        >
          常见问题解答
        </a>
        <div className={styles.QRCode}>
          <img loading={'lazy'} src={img_QRCode} alt='QRCode' fetchPriority={'low'} />
        </div>
      </div>
      <div style={{ height: 50 }} />
      <div className={styles.rule} ref={ref_content6}>
        <img loading={'lazy'} src={img_7_rule} alt='rule' className={styles.picture} />
        <div className={styles.ruleText} style={{ top: 166, left: 352 }}>
          {activityDetailsPage.startTime?.format('YYYY-MM-DD HH:mm:ss')}
        </div>
        <div className={styles.ruleText} style={{ top: 166, left: 532 }}>
          {activityDetailsPage.endTime?.format('YYYY-MM-DD HH:mm:ss')}
        </div>
        <div className={styles.ruleText} style={{ top: 200, left: 336 }}>
          {$announceTime.format('YYYY-MM-DD HH:mm:ss')}
        </div>
        <a
          className={styles.link}
          style={{ position: 'absolute', bottom: 292, left: 242 }}
          href='https://freelog2.freelog.cn/reader_freelog-query_id=62cce8f2456ff0002e328eb2?theme=%2Freader%3Fid%25M262cce8f2456ff0002e328eb2&w63518a=%2F'
          target='_blank'
        >
          《Freelog平台管理规范》
        </a>
      </div>
      <div style={{ height: 100 }} />
      <div style={{ backgroundColor: 'rgba(250, 251, 252, .0445)', width: '100%' }}>
        <FPropaganda />
        <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
          <div style={{ border: '1px solid #979797', width: 680, opacity: 0.15 }} />
        </div>
        <FPageFooter />
      </div>

      <div className={styles.navs}>
        <a
          className={$activated === 1 ? styles.activated : ''}
          onClick={() => {
            const info = ref_content1.current?.getBoundingClientRect();
            scrollTo((info?.top || 0) - 160);
          }}
        >
          活动背景
        </a>
        <div />
        <a
          className={$activated === 2 ? styles.activated : ''}
          onClick={() => {
            const info = ref_content2.current?.getBoundingClientRect();
            scrollTo((info?.top || 0) - 160);
          }}
        >
          活动日程
        </a>
        <div />
        <a
          className={$activated === 3 ? styles.activated : ''}
          onClick={() => {
            const info = ref_content3.current?.getBoundingClientRect();
            scrollTo((info?.top || 0) - 160);
          }}
        >
          活动奖励
        </a>
        <div />
        <a
          className={$activated === 4 ? styles.activated : ''}
          onClick={() => {
            const info = ref_content4.current?.getBoundingClientRect();
            scrollTo((info?.top || 0) - 160);
          }}
        >
          活动赛道
        </a>
        <div />
        <a
          className={$activated === 5 ? styles.activated : ''}
          onClick={() => {
            const info = ref_content5.current?.getBoundingClientRect();
            scrollTo((info?.top || 0) - 160);
          }}
        >
          活动答疑
        </a>
        <div />
        <a
          className={$activated === 6 ? styles.activated : ''}
          onClick={() => {
            const info = ref_content6.current?.getBoundingClientRect();
            scrollTo((info?.top || 0) - 160);
          }}
        >
          活动规则
        </a>
      </div>
      <div
        className={styles.submit}
        onClick={() => {
          commitWorks();
        }}
      >
        <img loading={'eager'} fetchPriority={'high'} src={img_sumbit} alt='submit' />
      </div>

      <div
        className={styles.share}
        onClick={async () => {
          fWeiXinShare({
            configs: {
              title: activityDetailsPage.pageTitle,
              desc: activityDetailsPage.description,
              link: self.location.href,
              imgUrl: activityDetailsPage.cover,
            },
          });
          await FServiceAPI.Activity.pushMessageTask({
            taskConfigCode: 'T0001004',
            meta: { activityId: activityDetailsPage.activityID },
          });
        }}
      >
        <img loading={'eager'} fetchPriority={'high'} src={img_share} alt='share' />
      </div>

      <FModal
        open={$showModal}
        closable={false}
        maskClosable={true}
        width={650}
        centered={true}
        onCancel={() => {
          set$showModal(false);
        }}
      >
        <div className={styles.content}>
          <div className={styles.text}>
            <div>开发者召集令！Freelog主题/插件开发大赛 第一期正在进行中！</div>
            <div style={{ height: 20 }} />
            <div>
              点击这里开始Freelog之旅：
              <a className={styles.link} href={self.location.href} target={'_blank'}>
                {self.location.href}
              </a>
            </div>
            <div style={{ height: 20 }} />
            <div>邀请码：{$invitationCode}</div>
            <div style={{ height: 20 }} />
          </div>
          <div style={{ height: 25 }} />
          <div
            className={[styles.buttonFilled].join(' ')}
            style={{ width: 82, height: 38, borderRadius: 4 }}
            onClick={() => {
              copy(
                `开发者召集令！Freelog主题/插件开发大赛 第一期正在进行中！
立即注册，参与主题/插件开发，赢取丰厚现金好礼！
点击这里开始Freelog之旅：${self.location.href}
邀请码：${$invitationCode}`,
                {
                  format: 'text/plain',
                },
              );
              fCenterMessage({ message: '复制成功' });
            }}
          >
            复制内容
          </div>
        </div>
      </FModal>
    </div>
  );
}

export default connect(({ activityDetailsPage }: ConnectState) => ({
  activityDetailsPage,
}))(Widget);
